import React, { type CSSProperties } from 'react'
import styles from './index.module.css'
import { Typography, type TypographySizes } from '../..'
import { cn } from '@s4l/utility-css'

interface INotificationDotProps {
  count: number
  size?: 'small' | 'medium'
  color?: CSSProperties['color']
}
const NotificationDot = ({
  count,
  size = 'small',
  color = 'var(--color-error-500)',
}: INotificationDotProps) => {
  const sizeTypography: TypographySizes<'caption'> = size === 'small' ? 's' : 'l'

  return (
    <div
      data-testid="notification-dot"
      style={{
        backgroundColor: color,
      }}
      className={cn(styles.notificationDot, {
        [styles.small]: size === 'small',
        [styles.medium]: size === 'medium',
      })}
    >
      <Typography variant="caption" size={sizeTypography} bold>
        {count}
      </Typography>
    </div>
  )
}

NotificationDot.displayName = 'NotificationDot'
export default NotificationDot
